import request from '@/utils/request'

// 获取所有预警记录列表
export function getAlertRecordsList(params = {}) {
  return request({
    url: '/alert-records/list',
    method: 'get',
    params
  })
}

// 根据ID查询预警记录
export function getAlertRecordById(id) {
  return request({
    url: `/alert-records/${id}`,
    method: 'get'
  })
}

// 根据状态查询预警记录
export function getAlertRecordsByStatus(status) {
  return request({
    url: `/alert-records/status/${status}`,
    method: 'get'
  })
}

// 根据预警类型查询预警记录
export function getAlertRecordsByType(alertType) {
  return request({
    url: `/alert-records/type/${alertType}`,
    method: 'get'
  })
}

// 根据时间范围查询预警记录
export function getAlertRecordsByTimeRange(startTime, endTime) {
  return request({
    url: '/alert-records/time-range',
    method: 'get',
    params: {
      startTime,
      endTime
    }
  })
}

// 新增预警记录
export function addAlertRecord(data) {
  return request({
    url: '/alert-records',
    method: 'post',
    data
  })
}

// 处理预警记录
export function handleAlertRecord(id, processComment, processActions) {
  return request({
    url: `/alert-records/${id}/handle`,
    method: 'put',
    params: {
      processComment,
      processActions
    }
  })
}

// 忽略预警记录
export function ignoreAlertRecord(id) {
  return request({
    url: `/alert-records/${id}/ignore`,
    method: 'put'
  })
}

// 删除预警记录
export function deleteAlertRecord(id) {
  return request({
    url: `/alert-records/${id}`,
    method: 'delete'
  })
}

// 获取预警统计信息
export function getAlertRecordsStatistics() {
  return request({
    url: '/alert-records/statistics',
    method: 'get'
  })
}

// 获取最近的预警记录
export function getRecentAlertRecords(limit = 10) {
  return request({
    url: '/alert-records/recent',
    method: 'get',
    params: { limit }
  })
}